// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"d91703cf","1815":"9ec38c90","9201":"09cc3901","9843":"ed938b91"}[chunkId] + ".chunk.css";
};